export class ListScanJobTypesResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "scanJobTypes",
            "baseName": "scanJobTypes",
            "type": "Array<ScanJobType>",
            "format": ""
        },
        {
            "name": "pagination",
            "baseName": "pagination",
            "type": "Pagination",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListScanJobTypesResponse.attributeTypeMap;
    }
    constructor() {
    }
}
